import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '@/api/api';
import { ENDPOINT } from '@/constants/endpoints';
import { Scope, UUID } from '@/types/common';
import { GetAllLeadersResponse, LeadersDetailsData } from '@/types/leaders';

type LeadersPayload = {
  scope: Scope;
  period: string;
  leaderId?: UUID;
  department?: string[];
  offset?: number;
  limit?: number;
  sortby?: string;
};

type QuestionPayload = {
  scope: Scope;
  leaderId: UUID;
};

export const leadersApi = createApi({
  reducerPath: 'leadersApi',
  baseQuery: axiosBaseQuery,
  endpoints: builder => ({
    getLeaders: builder.query<GetAllLeadersResponse, LeadersPayload>({
      query: params => ({
        url: ENDPOINT.LEADERS.GET_ALL(),
        method: 'GET',
        params,
      }),
    }),
    getLeader: builder.query<LeadersDetailsData, QuestionPayload>({
      query: ({ scope, leaderId }) => ({
        url: ENDPOINT.LEADERS.GET(leaderId),
        method: 'GET',
        params: { scope },
      }),
    }),
  }),
});

export const { useGetLeaderQuery, useGetLeadersQuery } = leadersApi;
